import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class Constants {
  STATUS_INITIATE = 100;

  STATUS_REJECTED = 150;

  STATUS_SUCCESS = 200;

  STATUS_AUTH_TOKEN_NOT_VALID = 1200;

  INTERNAL_SERVER_ERROR = 500;

  TRUE = 1;

  FALSE = 0;

  ANY = -1;

  GENERAL_INFO_STEP = 1;

  PERSONAL_INFO_STEP = 2;

  TRAVEL_INFO_STEP = 3;

  CONTACT_INFO_STEP = 4;

  SUPPORTING_DOCUMENTS_STEP = 5;

  TRAVEL_HISTORY_STEP = 6;

  SECURITY_AND_CRIMINAL_HISTORY_STEP = 7;

  BIOMETRIC_INFORMATION_STEP = 8;

  PAYMENT_ALREADY_COMPLETE = 1119;

  RESEND_VERIFICATION_LINK_TIME = 60; //THIS TIME IS IN SECONDS

  MIN_DATE_OF_BIRTH_YEAR = 1900;

  MINIMUM_AGE_VALUE = 18;

  MAXIMUM_AGE_VALUE = 100;

  VISA_TYPE = 30;

  USER_IMAGE_REQUIRED_SIZE_IN_MB = 1;

  USER_IMAGE_REQUIRED_WIDTH = 600;

  USER_IMAGE_REQUIRED_HEIGHT = 600;

  BLANK = '';

  MINOR = 'MINOR';

  ADULT = 'ADULT';

  SENIOR_CITIZEN = 'SENIOR_CITIZEN';

  MR = 'MR';

  MRS = 'MRS';

  MISS = 'MISS';

  MS = 'Ms';

  MASTER = 'Master';

  DR = 'Dr';

  PROF = 'Prof';

  OTHER = 'Other';

  MALE = 'MALE';

  FEMALE = 'FEMALE';

  SINGLE = 'SINGLE';

  MARRIED = 'MARRIED';

  WIDOWED = 'WIDOWED';

  DIVORCED = 'DIVORCED';

  FATHER = 'FATHER';

  MOTHER = 'MOTHER';

  BROTHER = 'BROTHER';

  SISTER = 'SISTER';

  SON = 'SON';

  DAUGHTER = 'DAUGHTER';

  FRIEND = 'FRIEND';

  RELATIVE = 'RELATIVE';

  APPLICATION_PAYMENT = 'APPLICATION_PAYMENT';


  ENCRYPT_DECRYPT_KEY = 'VOA_ENCRYPT_DECRYPT_KEY';

  ENCRYPT_DECRYPT_MASTER_KEY = '89085G5GH85QW75E';

  ENCRYPT_DECRYPT_MASTER_PASSWORD = 'PS852AA96DRK3L93978Q9L85672IWD63';

  ENCRYPT_DECRYPT_MASTER_SALT = 'NIS_USER';

  FRESH = 'FRESH';

  RENEW = 'RENEW';

  STANDARD = 'STANDARD';

  DIPLOMATIC = 'DIPLOMATIC';

  OFFICIAL = 'OFFICIAL';

  EXPIRED = 'EXPIRED';

  PAGE_EXHAUSTED = 'PAGE_EXHAUSTED';

  LOST_REPLACEMENT_REQUEST = 'LOST_REPLACEMENT_REQUEST';

  DAMAGED_PASSPORT = 'DAMAGED_PASSPORT';

  RESUME_APPLICATION = 'RESUME_APPLICATION';

  PAYMENT_STATUS = 'PAYMENT_STATUS';

  APPLICATION_ID = 'applicationId';

  REF_NUM_SEQUENCE = 'refNumSequence';

  MOBILE_NUMBER = 'mobileNumber';

  DATE_OF_BIRTH = 'dateOfBirth';

  EMAIL_ID = 'emailId';

  DEFAULT_SELECT_OPTION_LABEL = 'Choose Option';

  NOT_PROVIDED = 'Not Provided';

  DEFAULT_LOADER_ID = 'master';

  RADIO_FIELD = 'radio';

  CHECKBOX_FIELD = 'checkbox';

  TEXT_FIELD = 'text';

  SELECT_FIELD = 'select';

  USA_COUNTRY_CODE = 'US';

  APPLICATION_DOWNLOAD = 'APPLICATION_DOWNLOAD';

  RECEIPT_DOWNLOAD = 'RECEIPT_DOWNLOAD';

  REQUEST_RESOURCE_BACK_OFFICE = 'BACK_OFFICE';

  INCOMPLETE = 'INCOMPLETE';

  UNPAID = 'UNPAID';

  PAID = 'PAID';

  ABUJA = 'ABUJA';

  KANO = 'KANO';

  LAGOS = 'LAGOS';

  CALABAR = 'CALABAR';

  RIVERS = 'RIVERS';

  ENUGU = 'ENUGU';

  F5A = 'F5A';

  F3B = 'F3B';

  F6A = 'F6A';

  F7F = 'F7F';

  F7I = 'F7I';

  F9B = 'F9B';

  AIR = 'Air';

  LAND = 'Land';

  SEA = 'Sea'

  FILE_TYPE_PDF = 'application/pdf';

  JS_DEFAULT_DATE_FORMAT = 'MM/dd/yyyy';

  MAX_DEPENDENTS = 5

  MAX_PAYMENT = 5

  MAX_AMOUNT = 900
}
